import React from "react"

import ComponentFactory from "./parsers/ComponentFactory"
import * as testimonialSectionStyles from "../styles/TestimonialSection.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

export default function TestimonialSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `testimonial-section-heading`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const pageContentWrapperProps = {
    pageContext: props.pageContext,
    modals: props.modals,
  }

  const components = ComponentFactory(
    content.innerHTML,
    pageContentWrapperProps
  ).filter(c => c.type !== `div`)

  return (
    <>
      <div
        className={`row ${props.className} ${testimonialSectionStyles.wrapper}`}
      >
        <div>
          <div className={`row ${props.className} ${testimonialSectionStyles.innerWrapper}`}>
            <div className={`col-11 ${testimonialSectionStyles.intro}`}>
              <h2 className={`${testimonialSectionStyles.title}`}>{title}</h2>
            </div>
          </div>
          <div className={`row ${testimonialSectionStyles.testimonialGroup}`}>
            {components &&
              components.map((comp, indx) => (
                <div
                  key={indx}
                  className={`col-12 col-xl-4 ${testimonialSectionStyles.ctaHolder}`}
                >
                  <>{comp}</>
                </div>
              ))}
          </div>

        </div>

      </div>
    </>
  )
}
